import React from "react";
import { Card } from "react-bootstrap";
import "./styles.scss";

const ContentAdmin = () => {
  return (
    <div>
      <Card className="admin-container">
        <Card.Body>
          <Card.Title>Administração</Card.Title>
          <Card.Text>
            Bem-vindo ao painel de administração do sistema. Aqui você pode
            gerenciar as categorias e as questões do sistema. <br></br> Para
            começar, selecione uma das opções disponíveis no menu lateral
            esquerdo.
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ContentAdmin;
